<template>
  <div class=" text-shadow--custom">
    <div
      class="d-flex carroussel-container2"
    >
      <div
      style="width:60%;scale:50%;margin-top:-50px;"
      >
        <div class="inline-block mb-4 self-center md:self-start">
          <span
            class="px-3 py-1 text-sm font-semibold text-primary-foreground bg-primary rounded-full text-shadow--custom"
            >{{ items[current].head }}</span
          >
        </div>
        <h1
          class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-4 leading-tight text-shadow--custom texto-claro"
        >
          {{ items[current].title }}
          <span class="text-primary text-shadow--custom">{{ items[current].title2 }}</span>
        </h1>
        <p
          class="text-base sm:text-lg text-muted-foreground mb-6 max-w-lg mx-auto md:mx-0 text-white text-shadow--custom texto-claro"
        >
          <span class="texto-claro">{{ items[current].subtitle }}</span>
        </p>
        <div
          class="flex flex-col sm:flex-row gap-4 justify-center md:justify-start"
        >
          <button
            @click="$router.push('/products')"
            data-slot="button"
            class="rounded inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive bg-primary text-primary-foreground hover:bg-primary/90 h-10 rounded-md px-6 has-[&gt;svg]:px-4 gap-2"
          >
            Explorar Produtos</button
          >
        </div>
        <div class="grid grid-cols-3 gap-4 mt-8 md:mt-12">
          <div v-for="(info, index) in items[current].infos" :key="index">
            <p class="text-xl sm:text-2xl md:text-3xl font-bold text-primary">{{ info.value }}</p>
            <p class="text-xs text-muted-foreground">
              {{ info.description }}
            </p>
          </div>
        </div>
      </div>
      
      <div
      style="width:40%;scale:50%;margin-top:-50px;"
      >
        <div class="relative w-full h-full flex items-center justify-center hidden md:block" v-if="items.length > 1" style="scale:0.5;opacity:0.1;position:absolute;left:-20%;z-index:1;">
          <div class="relative z-20 w-40 h-48 md:w-56 md:h-64 mx-4 md:mx-0">
            <div
              style="scale:1.3"
              class="bg-item-produto-carrossel2 relative w-full h-full bg-gradient-to-br from-primary/30 via-secondary to-card rounded-xl p-6 flex items-center justify-center overflow-hidden group shadow-2xl"
            >
              <div
                class="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-primary/20 opacity-0 group-hover:opacity-100 transition-all duration-500"
              ></div>
              <div
                class="absolute -inset-1 bg-gradient-to-r from-primary via-blue-500 to-primary rounded-xl blur-2xl opacity-0 group-hover:opacity-75 transition-all duration-500 -z-10"
              ></div>
              <img
                :src="items[current - 1].image"
                :alt="items[current - 1].nome"
                class="w-full h-full object-contain relative z-10 transform group-hover:scale-105 transition-transform duration-500"
              />
              <div
              
              style="font-size:15px !important;"
                class="absolute bottom-4 right-4 bg-primary/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-bold text-primary-foreground z-20"
              >
                {{ items[current - 1].tag }}
              </div>
            </div>
            <div class="text-center mt-4 pt-4">
              <h2 class="text-xl md:text-2xl font-bold text-foreground texto-claro">
                <span class="texto-claro">{{ items[current - 1].nome }}</span>
              </h2>
            </div>
          </div>
        </div>

        <div class="relative w-full h-full flex items-center justify-center" style="z-index:2">
          <div class="relative z-20 w-32 h-40 sm:w-40 sm:h-48 md:w-56 md:h-64 mx-4 md:mx-0">
            <div
              style="scale:1.3"
              class="bg-item-produto-carrossel2 relative w-full h-full bg-gradient-to-br from-primary/30 via-secondary to-card rounded-xl p-6 flex items-center justify-center overflow-hidden group shadow-2xl"
            >
              <div
                class="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-primary/20 opacity-0 group-hover:opacity-100 transition-all duration-500"
              ></div>
              <div
                class="absolute -inset-1 bg-gradient-to-r from-primary via-blue-500 to-primary rounded-xl blur-2xl opacity-0 group-hover:opacity-75 transition-all duration-500 -z-10"
              ></div>
              <img
                :src="items[current].image"
                :alt="items[current].nome"
                class="w-full h-full object-contain relative z-10 transform group-hover:scale-105 transition-transform duration-500"
              />
              <div
              style="font-size:8px !important;"
                class="absolute bottom-4 right-4 bg-primary/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-bold text-primary-foreground z-20"
              >
                {{ items[current].tag }}
              </div>
            </div>
            <div class="text-center mt-4 pt-4">
              <h2 class="text-base sm:text-xl md:text-2xl font-bold text-foreground">
                <span class="texto-claro">{{ items[current].nome }}</span>
              </h2>
            </div>
          </div>
        </div>

        <div class="relative w-full h-full flex items-center justify-center hidden md:block" v-if="items.length > 1" style="scale:0.5;opacity:0.1;position:absolute;left:20%;z-index:1;">
          <div class="relative z-20 w-40 h-48 md:w-56 md:h-64 mx-4 md:mx-0">
            <div
              style="scale:1.3"
              class="bg-item-produto-carrossel2 relative w-full h-full bg-gradient-to-br from-primary/30 via-secondary to-card rounded-xl p-6 flex items-center justify-center overflow-hidden group shadow-2xl"
            >
              <div
                class="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-primary/20 opacity-0 group-hover:opacity-100 transition-all duration-500"
              ></div>
              <div
                class="absolute -inset-1 bg-gradient-to-r from-primary via-blue-500 to-primary rounded-xl blur-2xl opacity-0 group-hover:opacity-75 transition-all duration-500 -z-10"
              ></div>
              <img
                :src="items[current + 1].image"
                :alt="items[current + 1].nome"
                class="w-full h-full object-contain relative z-10 transform group-hover:scale-105 transition-transform duration-500"
              />
              <div
              style="font-size:15px !important;"
                class="absolute bottom-4 right-4 bg-primary/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-bold text-primary-foreground z-20"
              >
                {{ items[current + 1].tag }}
              </div>
            </div>
            <div class="text-center mt-4 pt-4">
              <h2 class="text-xl md:text-2xl font-bold text-foreground texto-claro">
                <span class="texto-claro">{{ items[current + 1].nome }}</span>
              </h2>
            </div>
          </div>
        </div>
        
        <button
          @click="toNextCarroussel"
          class="absolute top-1/2 -translate-y-1/2 z-30 p-2 rounded-full bg-primary/20 hover:bg-primary/40 transition-colors"
          style="left: -25%"
          aria-label="Previous product"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-chevron-left h-6 w-6 text-primary"
          >
            <path d="m15 18-6-6 6-6"></path>
          </svg></button
        ><button
          @click="toNextCarroussel"
          class="absolute top-1/2 -translate-y-1/2 z-30 p-2 rounded-full bg-primary/20 hover:bg-primary/40 transition-colors"
          style="right: -25%"
          aria-label="Next product"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-chevron-right h-6 w-6 text-primary"
          >
            <path d="m9 18 6-6-6-6"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$api.getBanners()
      .then(res=>{
        if (res?.data?.banners){
          this.items = res.data.banners
        }
        console.log('peguei os banners', JSON.stringify(this.items));
        
        
      })
    setInterval(() => {
      if (!this.automatic) return;
      this.nextCarroussel();
    }, 2500);
  },

  data() {
    return {
      automatic: true,
      current: 1,
      items: [],
    };
  },
  methods: {
    toNextCarroussel() {
      this.automatic = false;
      this.nextCarroussel();
    },
    nextCarroussel() {
      // Ajusta o 'current' para o próximo item, voltando ao início (0) se atingir o final do array.
      this.current = (this.current + 1) % this.items.length;
    },
    mailto() {
      window.open("https://www.mx3network.com/contato");
    },
  },
};
</script>

<style scoped>
/* Estilos existentes (mantidos inalterados) */
.bg-item-produto-carrossel2 {
  background: linear-gradient(45deg, #000719, rgba(255, 255, 255, 0.068));
}

/* 1. Definindo o Container para o Efeito de Brilho */
.carroussel-container2 {
  /* H-AUTO e MIN-H para se adaptar ao conteúdo em mobile */
  /* md:h-[85vh] preserva a altura para desktop */
  height: 35vh !important;
  background-image: url("@/assets/img/banner/banner-base.jpg");
  background-position: center;
  background-size: auto;
  background-repeat: repeat-x;
  /* Reduzindo o padding lateral em mobile para dar mais espaço, mantendo 15% em md */
  padding-right: 5%;
  padding-left: 5%;
  /* ✨ ALTERAÇÕES AQUI: Necessário para o posicionamento do ::before */
  position: relative;
  overflow: hidden;
}
@media (min-width: 768px) {
  .carroussel-container2 {
    padding-right: 15%;
    padding-left: 15%;
  }
}


.texto-claro {
  color: white !important;
}

.text-shadow--custom {
  text-shadow: 2px 2px 2px black !important;
}

/* 2. Aplicação do Efeito de Brilho (Grosso, Sutil e Lento) */
.carroussel-container2::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  z-index: 1;

  /* ✨ ALTERAÇÃO: Aumentando a largura da faixa e mantendo a sutileza */
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0) -50%,
    /* Início da faixa grossa (40%) */ rgba(255, 255, 255, 0.01) 70%,
    /* Pico do brilho (50% - 20% de opacidade) */ rgba(255, 255, 255, 0) 500%,
    /* Fim da faixa grossa (60%) */ rgba(255, 255, 255, 0) 100%
  );

  /* Mantido o ângulo e a velocidade lenta (8s) */
  transform: skewX(-45deg);
  animation: brilhoSuave 3s infinite ease-in-out;
}

/* 3. Definição da Animação */
@keyframes brilhoSuave {
  0% {
    left: -150%; /* Inicia o brilho completamente fora da div à esquerda */
  }
  100% {
    left: 150%; /* Move o brilho para fora da div à direita */
  }
}
</style>

<style src="./Carroussel2.css"></style>